export {
  default as ProviderComponent,
  renderProviderComponent,
} from './ProviderComponent';
export * from './config';
